/** @format */

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import tw from 'twin.macro';
import { css } from 'styled-components/macro'; //eslint-disable-line
import { SectionHeading } from 'components/misc/Headings.js';
import { Container } from 'components/misc/Layouts.js';
import { ReactComponent as ChevronDownIcon } from 'feather-icons/dist/icons/chevron-down.svg';

const Heading = tw(SectionHeading)`w-full`;

const Column = tw.div`flex flex-col items-center`;
const HeaderContent = tw.div``;

const FAQSContainer = tw.dl`sm:mt-12 max-w-4xl relative`;
const FAQ = tw.div`cursor-pointer select-none mt-2 px-8 sm:px-10 py-5 sm:py-4 rounded-lg text-black hover:text-gray-900 hover:bg-gray-300 transition duration-300`;
const Question = tw.dt`flex justify-between items-center`;
const QuestionText = tw.span`text-lg lg:text-xl font-semibold text-text`;
const QuestionToggleIcon = motion(styled.span`
	${tw`ml-2 transition duration-300`}
	svg {
		${tw`w-6 h-6`}
	}
`);
const Answer = motion(tw.dd`pointer-events-none text-sm sm:text-base leading-relaxed`);

const Faq = ({
	heading = 'Q&A',
	faqs = [
		{
			question: 'What is the difference between credit report and credit score?',
			answer: 'Yes, it is, if you have a membership with us. Otherwise it is charged as per the menu. Some limits do apply as to how much items can be included in your lunch. This limit is enough for any one person and merely exists to discourage abusal of the system.',
		},
		{
			question: 'How long does it take to improve my credit score?',
			answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
		},
		{
			question: 'Can I do it myself?',
			answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
		},
		{
			question: 'Can I cancel my subscription anytime ?',
			answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
		},
	],
}) => {
	const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);

	const toggleQuestion = questionIndex => {
		if (activeQuestionIndex === questionIndex) setActiveQuestionIndex(null);
		else setActiveQuestionIndex(questionIndex);
	};

	return (
		<Container style={{ paddingBottom: '4rem', marginTop: '3rem' }}>
			<Column>
				<HeaderContent>
					<Heading>{heading}</Heading>
				</HeaderContent>
				<FAQSContainer>
					{faqs.map((faq, index) => (
						<FAQ
							key={index}
							onClick={() => {
								toggleQuestion(index);
							}}
							className="group">
							<Question>
								<QuestionText>{faq.question}</QuestionText>
								<QuestionToggleIcon
									variants={{
										collapsed: { rotate: 0 },
										open: { rotate: -180 },
									}}
									initial="collapsed"
									animate={activeQuestionIndex === index ? 'open' : 'collapsed'}
									transition={{ duration: 0.02, ease: [0.04, 0.62, 0.23, 0.98] }}>
									<ChevronDownIcon />
								</QuestionToggleIcon>
							</Question>
							<Answer
								variants={{
									open: { opacity: 1, height: 'auto', marginTop: '16px' },
									collapsed: { opacity: 0, height: 0, marginTop: '0px' },
								}}
								initial="collapsed"
								animate={activeQuestionIndex === index ? 'open' : 'collapsed'}
								transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}>
								{faq.answer}
							</Answer>
						</FAQ>
					))}
				</FAQSContainer>
			</Column>
		</Container>
	);
};

export default Faq;
